import { FC, useContext } from 'react'
import styled from 'styled-components'
import { validFor } from '@/theme/validFor'
import { LandingPageSection } from '@/network/graphql.g'
import { H1 } from '@/components/atoms/typography'
import Link from '@/components/atoms/link'
import { Box, Flex } from '@/components/atoms/Grid'
import { BigAccentButton } from '@/components/atoms/button'
import { StoreContext } from '@/providers/storeProvider'

type BlackFridayCategoriesProps = {
  position: string
  blackFridaySections: LandingPageSection[]
}

const BlackFridayCategories: FC<BlackFridayCategoriesProps> = ({
  position,
  blackFridaySections
}) => {
  const blackFridayCategory = blackFridaySections.find(
    (element) => element.position === position
  )

  const blackFridaySortCategories = blackFridayCategory?.categories
    ? [...blackFridayCategory.categories].sort((a, b) => a.sort - b.sort)
    : []

  const { isBezvasport } = useContext(StoreContext)

  return (
    <Wrapper position={position} isBezvasport={isBezvasport}>
      <StyledFlex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <StyledH1>{blackFridayCategory?.name}</StyledH1>
        {blackFridaySortCategories.map((item) => (
          <Link href={item.link} key={item?.sort}>
            <StyledBlackFridayButton title={item.name} />
          </Link>
        ))}
      </StyledFlex>
    </Wrapper>
  )
}

export default BlackFridayCategories

const Wrapper = styled(Box)`
  height: 100%;
  ${validFor.mobile`
  width: 100%;
  margin-bottom: 5px
  `}
  ${validFor.tablet`
    width:50%
  `}
  ${validFor.desktop`
    width: 50%
  `} 
  text-align: center;
  &:hover {
    ${({ isClickable }) => isClickable && 'cursor: pointer'}
  }
`
const StyledBlackFridayButton = styled(BigAccentButton)`
  background-color: ${(props) => props.theme.colors.background};
  color: ${(props) => props.theme.colors.onBackground};
  margin-bottom: 15px;
  width: 275px;
  ${validFor.mobile`
    width: 225px
  `}
  ${validFor.tablet`
    width: 225px
  `}
`
const StyledFlex = styled(Flex)`
  height: 100%;
`
const StyledH1 = styled(H1)`
  font-size: 32px;
  letter-spacing: 2px;
`
